import { render } from "./SnehaSparshamApplicationEdit.vue?vue&type=template&id=006ad45f&scoped=true"
import script from "./SnehaSparshamApplicationEdit.vue?vue&type=script&lang=js"
export * from "./SnehaSparshamApplicationEdit.vue?vue&type=script&lang=js"

import "./SnehaSparshamApplicationEdit.vue?vue&type=style&index=0&id=006ad45f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006ad45f"]])

export default __exports__